const Header = ({ open, setOpen}) => {
  const user = JSON.parse(localStorage.getItem('user'));
  var firstName = '';
  var lastName = '';
  if (user) {
    firstName = user.name.split(' ')[0];
    lastName = user.name.split(' ')[1];
  }
  return (
    <header className={`flex ${window.innerWidth < 768&& !open ? 'justify-between' : 'justify-end'} items-center px-6 py-4 border-b bg-[#212121] text-white`}>
      {!open && window.innerWidth < 768 && <div className="w-12 h-12 rounded-full bg-black flex items-center justify-center text-white font-semibold" onClick={() => setOpen(true)}>☰</div>}
      {user && <div className="w-12 h-12 rounded-full bg-black flex items-center justify-center text-white font-semibold">
        {`${firstName.charAt(0).toUpperCase()}${lastName ? lastName.charAt(0).toUpperCase() : ''}`}
      </div>}
    </header>
  );
};

export default Header;
